/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorArticleFooter from 'base/components/labrador/ArticleFooter';

export const DynamicLabradorArticleFooter: typeof LabradorArticleFooter = (props) => {
    return <ErrorBoundary><LabradorArticleFooter {...props} /></ErrorBoundary>;
}
export type DynamicLabradorArticleFooterProps = PropsFromComponent<typeof LabradorArticleFooter>;
